import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.array.iterator.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.promise.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es6.object.assign.js";
import "D:\\coding\\pmv5-fe\\node_modules\\core-js\\modules\\es7.promise.finally.js";
import Vue from "vue";
import "./config/http";
import ActivationApp from "./Activation.vue";
import iView from "iview";
import "./styles/index.less";
import "./styles/pmv5.css";
Vue.use(iView);
new Vue({
  render: function render(h) {
    return h(ActivationApp);
  }
}).$mount("#app");